import { render, staticRenderFns } from "./RatingDirectionsGrid.vue?vue&type=template&id=0d27c1da"
import script from "./RatingDirectionsGrid.vue?vue&type=script&lang=js"
export * from "./RatingDirectionsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports